import * as React from 'react';
import MultiSelectModal from '../../../../misc/components/queryTable/MultiSelectModal';
import {
    Query,
    QueryCondition,
    QueryFilter,
    SpirometrySessionMetadata,
    SessionScheduleItem
} from "../../../../misc/api/apiTypes";
import { useWebPortalLegacyClient } from '../../../../misc/api/WebPortalTokenClient';
import { SessionTypes } from '../../../../misc/api/ApiSessionTypes';

export const SessionFilterMember = "SessionLabel";
const SessionQueryMember = "Label";
const SessionFilterQueryCondition = QueryCondition.Equal;
export const SessionHeader = "Session";

interface SessionFilterProps {
    studyId: string;
    onApply: (member: string, condition: QueryCondition, values: string[]) => void;
    onClose: () => void;
    query: Query<SpirometrySessionMetadata>;
}

const GetQueryFilter = (query: Query<SpirometrySessionMetadata>): QueryFilter => {
    return query.Filters.find(filter => filter.Member === SessionFilterMember && filter.Condition === SessionFilterQueryCondition);
}

const SessionFilterModal = ({ studyId, onApply, onClose, query }: SessionFilterProps): JSX.Element => {

    const queryFilter = GetQueryFilter(query) || { Values: [] };

    const [values, setValues] = React.useState<string[]>(queryFilter.Values as string[]);

    const [allSessions, setAllSessions] = React.useState<SessionScheduleItem[]>([]);
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getSession = async () => {
            const result = await legacyClient.getSessionSchedule({ Filters: [{ Member: "StudyId", Values: [studyId] }] });
            const filteredSessionSchedule = result.Data.filter(item => item.SessionTypeId === SessionTypes.Dlco);
            setAllSessions(filteredSessionSchedule);
        };
        getSession();
    }, []);

    const sortedOptions = [...allSessions]
        .sort((a, b) => a.DisplayOrder - b.DisplayOrder)
        .sort((a, b) => a.VisitScheduleItem.DisplayOrder - b.VisitScheduleItem.DisplayOrder);

    return (<MultiSelectModal header={SessionHeader + ' Filter'}
        isLoading={!allSessions}
        show={true}
        options={sortedOptions}
        valueKey={SessionQueryMember}
        labelKey={SessionQueryMember}
        values={values}
        onChange={(updatedValues: string[]) => {
            setValues(updatedValues.length > 0 ? updatedValues.map(v => v[SessionQueryMember]) : null);
        }}
        onApply={() => {
            onApply(SessionFilterMember, SessionFilterQueryCondition, values);
        }}
        onClear={() => {
            onApply(SessionFilterMember, SessionFilterQueryCondition, []);
        }}
        onClose={onClose}
    />)
}

export default SessionFilterModal;
